import script from "./GearViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./GearViewer.vue?vue&type=script&setup=true&lang=js"

import "./GearViewer.vue?vue&type=style&index=0&id=0c5f3a2c&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/set-repository-web-glasses/glasses-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c5f3a2c"]])

export default __exports__